module.exports = __webpack_public_path__ + "static/media/单位号码证明函模板.b6ccc0e6.docx";